import { render, staticRenderFns } from "./FormComponentConfig.vue?vue&type=template&id=438ae0f0&scoped=true"
import script from "./FormComponentConfig.vue?vue&type=script&lang=js"
export * from "./FormComponentConfig.vue?vue&type=script&lang=js"
import style0 from "./FormComponentConfig.vue?vue&type=style&index=0&id=438ae0f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438ae0f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438ae0f0')) {
      api.createRecord('438ae0f0', component.options)
    } else {
      api.reload('438ae0f0', component.options)
    }
    module.hot.accept("./FormComponentConfig.vue?vue&type=template&id=438ae0f0&scoped=true", function () {
      api.rerender('438ae0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/FormComponentConfig.vue"
export default component.exports